import { useCallback, useEffect, useState } from 'react'
import type { CSSProperties, RefObject } from 'react'

const FADE = '28px'

/**
 * Затухание у края горизонтально прокручиваемой полосы (вкладки на узком экране):
 * без него обрезанная правым краем вкладка выглядела концом списка, и про
 * остальные вкладки автор не догадывался. Край гаснет только с той стороны, где
 * ещё есть что прокрутить. Маска не цвет, а прозрачность — тема ни при чём.
 */
export const useScrollFade = (ref: RefObject<HTMLElement | null>): CSSProperties | undefined => {
  const [edges, setEdges] = useState({ left: false, right: false })

  const measure = useCallback(() => {
    const el = ref.current
    if (!el) return
    const left = el.scrollLeft > 1
    const right = el.scrollLeft + el.clientWidth < el.scrollWidth - 1
    setEdges((prev) => (prev.left === left && prev.right === right ? prev : { left, right }))
  }, [ref])

  useEffect(() => {
    const el = ref.current
    if (!el) return
    measure()
    el.addEventListener('scroll', measure, { passive: true })
    const observer = new ResizeObserver(measure)
    observer.observe(el)
    return () => {
      el.removeEventListener('scroll', measure)
      observer.disconnect()
    }
  }, [ref, measure])

  if (!edges.left && !edges.right) return undefined
  const mask = `linear-gradient(to right, ${edges.left ? 'transparent' : '#000'} 0, #000 ${FADE}, #000 calc(100% - ${FADE}), ${edges.right ? 'transparent' : '#000'} 100%)`
  return { maskImage: mask, WebkitMaskImage: mask }
}
